import React from "react";
import Helmet from "react-helmet";
import {Link} from "react-router-dom"
function Footer(){
    return (
        <div>
          
            <footer className="main-footer">
        <div
          className="footer-top"
          style={{
            backgroundImage: "url(https://images.unsplash.com/photo-1527964275784-5ce8ddab3d8e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDV8fGV0aGlvcGlhfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60)",
          }}
        >
          <div className="auto-container">
            <div className="footer-info clearfix">
              <div className="single-item">
                <div className="inner" style={{background:"#272727"}}>
                  <div className="icon-box">
                    <i className="flaticon-mail" />
                  </div>
                  <h6>Email</h6>
                  <p>
                    <Link to="#">
                      enku@gmail.com
                    </Link>
                  </p>
                </div>
              </div>
              <div className="single-item" >
                <div className="inner" style={{background:"#272727"}}>
                  <div className="icon-box">
                    <i className="flaticon-phone" />
                  </div>
                  <h6>Call</h6>
                  <p>
                    <Link to="#">09111213145</Link>
                  </p>
                </div>
              </div>
              <div className="single-item">
                <div className="inner" style={{background:"#272727"}}>
                  <div className="icon-box">
                    <i className="flaticon-address" />
                  </div>
                  <h6>Address</h6>
                  <p>bole around megablock</p>
                </div>
              </div>
            </div>
            <div className="widget-section pt-2 pb-2">
              <div className="row clearfix">
               
                <div className="col-lg-6 col-md-6 col-sm-12 footer-column">
                  <div className="footer-widget links-widget">
                    <div className="widget-title">
                      <h4>Help</h4>
                    </div>
                    <div className="widget-content">
                      <ul className="links-list clearfix">
                        <li>
                         <Link to="/term">
                         Term of use
                         </Link>
                        </li>
                    
                        <li>
                        <Link to="/privacy">Privacy Policy</Link>
                        </li>
                        <li>
                          <Link to="/market">Buying guide</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                 <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                  <div className="footer-widget links-widget ml-30">
                    <div className="widget-title">
                      <h4>More</h4>
                    </div>
                    <div className="widget-content">
                      <ul className="links-list clearfix">
                        <li>
                          <Link to="/horescope">Horescope and gems</Link>
                        </li>
                        <li>
                        <Link to="/anniversary">Anniversary of gems</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> 
                <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                <div className="footer-widget logo-widget">
                    <figure className="footer-logo">
                      <Link to="/">
                      <img  style ={{ height:"65px",width:"105px" }} src="/assets/images/icons/logo.png"  alt />
              
                      </Link>
                    </figure>
                    <p>Join our newsletter and get latest updates</p>
                    <form action="contact.html" method="post">
                      <div className="form-group">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email Address"
                          required
                        />
                        <button>
                          <i className="fas fa-check" />
                        </button>
                      </div>
                    </form>
                    <ul className="social-links clearfix">
                      <li>
                        <h6>Connect:</h6>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-facebook-square" />
                        </Link>
                      </li>
                      <li>
                      <Link to="#">
                          <i className="fab fa-pinterest-p" />
                          </Link>
                      </li>
                      <li>
                      <Link to="#">
                          <i className="fab fa-instagram" />
                          </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom pt-2">
          <div className="auto-container">
            <div className="inner-box clearfix">
              <div className="copyright pull-left">
                <p>
                  © Copyright 2020 by <Link to="/">Enku</Link>
                </p>
              </div>

            </div>
          </div>
        </div>
      </footer>
      <button className="scroll-top scroll-to-target" data-target="html">
  <span className="fa fa-arrow-up" />
</button>
   
<Helmet>
        <script src="assets/js/bootstrap.min.js"></script>
        <script src="assets/js/popper.min.js"></script>
        <script src="assets/js/owl.js"></script>
        <script src="assets/js/wow.js"></script>

        <script src="assets/js/scrollbar.js"></script>
        <script src="assets/js/appear.js"></script>
        <script src="assets/js/validation.js"></script>
        <script src="assets/js/jquery.js"></script>
        <script src="assets/js/jquery.fancybox.js"></script>

        <script defer="defer" src="assets/js/script.js"></script>
      </Helmet>
        </div>
    )
}

export default Footer;